'use client'
import React, {useState} from 'react';
import styled from "styled-components";
import {text, Transition, white, hover} from "@/styles/globalStyleVars";
import Link from "next/link";
import {Img} from "@/components/common/ui/Img";
import reactHtmlParser from "react-html-parser";


const MisionSingle = ({title, description, image, offset, dataSpeed}) => {


    return (
        <StyledServicesSingle offset={offset} data-speed={dataSpeed ? dataSpeed : '1'} className='serviceSingle'  >
            <div className="image-content">
                <Img alt={title} src={image ? image : '/images/dynamic/common/mision.jpg'}/>
                <h6>{title ? reactHtmlParser(title)  : "Mission"}</h6>
                {
                    reactHtmlParser(description ? description : '<p>We envision a world where everyone has access to international education and migration opportunities, contributing to a more inclusive, interconnected, and educated global community.</p>')
                }

            </div>
        </StyledServicesSingle>
    );
};

const StyledServicesSingle = styled.div`
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    z-index: 1;
    
    .image-content{
        border-radius: 8px;
        padding-top: calc(320 / 455  * 100%);
        position: relative;
        overflow: hidden;
        
        @media(max-width: 1280px) and (min-width: 1024px){
            padding-top: calc(405 / 455  * 100%);
            
        } 
    }
    h6{
        font-size: 28px;
        font-weight: 500;
        color: white;
        line-height: 32px;
        position: absolute;
        top: 40px;
        left: 40px;
        right: 40px;
        @media(max-width: 500px){
            top: 15px;
            left: 15px;
            right: 15px;
        }
        
    }
    p{
        color: white;
        position: absolute;
        bottom: 40px;
        left: 40px;
        right: 40px;
        @media(max-width: 500px){
            bottom: 15px;
            left: 15px;
            right: 15px;
        }
    }

`;

export default React.memo(MisionSingle);
